import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_054.jpg';
page.games = [
  {
    id: 'page054_game0',
    icon: 'ikonaCwiczenie',
    color: '#FF808080',
    tooltip: 's. 54',
    pos: {
      x: LEFT,
      y: 40,
    },
    item: {
      id: 'page054_game0',
    },
  },
];
export default page;
